<script>
	import { format } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';
	import { Icon, Text } from '@Shelly/shelly-design-system/index';
	import { CAMERA_CLOUD_STORAGE_SCROLL_PARAM } from 'src/helpers/camera_cloud_storage_helpers';
	import { resetDrawerClose } from 'src/helpers/drawer_helpers';

	export let noResultsFound = {
		icon: 'fa-light fa-camera-cctv',
		title: $format('recordings_list_no_recordings', {
			default: 'No events recorded yet',
		}),
		description: $format('recordings_list_no_cloud_recordings_description', {
			default: 'Cloud Recordings will appear here when event is detected.',
		}),
	};
	/** Offers a way into Cloud Storage when the promo banner is not around (e.g. dismissed). */
	export let showCloudStorageLink = false;

	const cloudStoragePlansRoute = `/settings/premium?${CAMERA_CLOUD_STORAGE_SCROLL_PARAM}=1`;

	const openCloudStoragePlans = (event) => {
		event?.preventDefault();
		push(cloudStoragePlansRoute);
		resetDrawerClose();
	};
</script>

<div class="flex-full-height align-items-center">
	<Icon class="mb-m" size="l" icon={noResultsFound?.icon} />
	<Text styleType="body-small" class="mb-s text-bold text-center">
		{noResultsFound?.title}
	</Text>
	<Text class="text-color-muted text-center" styleType="body-extra-small">
		{noResultsFound?.description}
	</Text>
	{#if showCloudStorageLink}
		<Text
			href={`#${cloudStoragePlansRoute}`}
			class="pt-s size-m-button-min-height text-center"
			styleType="controls-small"
			noWrap
			on:click={openCloudStoragePlans}
		>
			{$format('link_learn_about_cloud_storage', { default: 'Learn about Cloud Storage' })}
		</Text>
	{/if}
</div>
